import { Component, OnInit } from '@angular/core';
import { MenusService } from 'src/app/services/menus.service';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-menu-select',
  templateUrl: './menu-select.component.html',
  styleUrls: ['./menu-select.component.scss'],
})
export class MenuSelectComponent implements OnInit {

  constructor(
    public menusSvc: MenusService,
    private popoverCtrl: PopoverController
  ) { }

  ngOnInit() {}

  onDismiss() {
    this.popoverCtrl.dismiss();
  }
}
